<template>
  <section class="grid-flex column">

    <div class="flex-1 flex row w100 middle">
      <div class="box">
        <div class="box-content">
          <div class="flex middle">
            <div class="flex-1">
              <div>
                Total de Vendas:
                <div class="margin-top-s">
                  <h2> {{  report.sale_count | number  }}</h2>  
                </div>
              </div>
            </div>

            <div class="flex-1">
              <div>
                Total de comissões: 
                <div class="margin-top-s">
                  <h2> {{  report.sale_sum | money  }}</h2>  
                </div>
              </div>
            </div>
          </div>
          <div class="flex  margin-top-l column">
            <div class="flex-1">
              <small>O total de <b>vendas</b> e <b>comissões</b> são referentes ao mês atual.</small>
            </div>
            <div class="flex-1">
              <small><b>Lembrando</b>: Apenas vendas efetuadas pelo seu link de divulgação irão contar no programa de parceiros.</small>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="flex-1 flex row w100 middle margin-top-l">
      <div class="flex-1 no-mobile">
        <h3>Histórico de Vendas</h3>
      </div>
      <div class="flex-1">
        <div class="flex w100 end filters-groupo-holder">
          <!-- pagination -->
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>
    </div>

    <div class="mobile">
        <h3>Histórico de Vendas</h3>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(sale, index) in sales" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>
                        {{ sale.name }}
                      </p>
                      <div class="flex column">
                        <div><small>#{{ sale.order_id }}</small></div>
                      </div>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <div class="max-status">
                          <p>Status:</p>
                          <small 
                            :class="{ 
                              approved: sale.status === 'approved',
                              failed: sale.status !== 'approved' && sale.status !== 'billet_printed'
                            }"
                          >
                            {{ _decode_status(sale.status) }}
                          </small>
                        </div>
                        <div>
                          <p>Comissão:</p>
                          <small
                            class="commission"
                            :class="{ 
                              approved: sale.status === 'approved',
                              failed: sale.status !== 'approved' && sale.status !== 'billet_printed'
                            }"
                          >
                          {{ sale.commission | money}}
                          <div class="no-value"></div>
                        </small>
                        </div>
                        <div>
                          <p>Compra:</p>
                          <small> {{ sale.created_at | date }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhuma venda. Assim que você tiver a
            primeira venda o valor da comissão vai aparecer na lista.
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getSales } from "@/services/sale";

const emptyData = {
  sale_sum: '-',
  sale_count: '-',
}

export default {
  name: "sale",
  components: { 
  },
  data() {
    return {
      loading: false,
      filters: {
        data: {},
        list: {},
      },
      report: Object.assign({}, emptyData),
      sales: [],
      totalSales: 1,
      offset: 10,
      page: 1,
    };
  },
  mounted() {
    this.getSales();
  },
  computed: {
    isEmpty() {
      return this.totalSales === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalSales % this.offset;
      let value = this.totalSales / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "page": {
      handler() {
        this.sales = [];
        this.getSales();
      }
    }
  },
  methods: {
    _decode_status(status) {

      let _map = {
        'approved': 'PAGO',
        'canceled': 'CANCELADO',
        'refunded': 'REEMBOLSO',
        'billet_printed': 'AGUARDANDO PAGAMENTO',
      }

      return _map[status] || status
    },
    getSales() {
      this.loading = true;
      let params = {
        page: this.page,
        offset: this.offset,
      };
      getSales(params)
        .then((result) => {
          this.sales = result.sales.map((s) => {
            return {
              id: s.id,
              name: s.name,
              order_id: s.order_id,
              commission: s.commission,
              created_at: s.created_at,
              updated_at: s.updated_at,
              status: s.status,
            };
          });
          this.totalSales = result.total
          this.report = result.report
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar vendas",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

@media screen and (max-width: 1024px) {

  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ':'
      }
      small {
        margin-left: 8px;
      }
    }

  }
  .action {
    margin-top: 16px;
  }

}

.max-status {
  max-width: 50px;
}

.approved {
  color: green;
}

.failed {
  color: red;
}

.no-value {
  display: none;
}

.commission {
  position: relative;
  &.failed { 
    .no-value {
      display: inline;
      position: absolute;
      width: 100px;
      border-bottom: 2px solid red;
      top: 7px;
      left: -14px;
      // transform: rotate(-15deg); /* Equal to rotateZ(45deg) */
    }
  }
}


</style>
